import React from 'react';

const EDITABLE_REGION_CLASS = [
  'relative',
].join(' ');

function EditableListingInfoRegion({ canEdit = false, children, className = '', id }) {
  if (!canEdit) return children;

  return (
    <div
      id={id}
      data-listing-info-editable="true"
      className={[EDITABLE_REGION_CLASS, className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  );
}

export default EditableListingInfoRegion;
